export enum EnumTipoCobranca {
    ClienteFinal = 0,
    Revenda = 1,
    RevendaPagas = 2,
}